import axios from '@/config/axios'

const model={
    getTable(params){
        return axios({
            url:'/business/discount/cardiscount',
            method:'post',
            data:params
        })
    },
    addDiscount(params){
        return axios({
            url:'/business/discount/add',
            method:'post',
            data:params,
            msg:true
        })
    },
    updateDiscount(params){
        return axios({
            url:'/business/discount/update',
            method:'post',
            data:params,
            msg:true
        })
    },
    canelDiscount(params){
        return axios({
            url:'/business/discount/cancel',
            params:params,
            msg:true
        })
    },
    getCarNoList(params) {
        return axios({
            url:'/business/discount/findcar',
            method:'GET',
            params
        })
    },
    getCarNoTime(params) {
        return axios({
            url:'/business/discount/findintime',
            params
        })
    },
    getParkList() {
        return axios({
            url:'/business/discount/getPark',
            method:'GET'
        })
    },
    createCode(data) {
        return axios({
            url: '/business/discount/addDisQrCode',
            method: 'POST',
            data
        })
    },
    getCodeParams(params) {
        return axios({
            url: '/business/discount/getDisQrCode',
            params
        })
    },
    setCodeFlashTime(params) {
        return axios({
            url: '/business/discount/flushDisQrCode',
            params
        })
    },
}

export default model


// WEBPACK FOOTER //
// ./src/models/create.js